const CANVAS_W = 600;
const CANVAS_H = 600;

class ThumbnailCropCords {
  constructor(rect, outputAspectRatio) {
    this.outputAspectRatio = outputAspectRatio;
    this.isFitCrop = rect.some(v => v < 0);

    [this.x, this.y, this.width, this.height] = rect
      .map('trunc' in Math ? Math.trunc : Math.floor)
      .map(Math.abs);
  }

  get canvasWidth() {
    if (this.isFitCrop) {
      if (this.tendsLandscape) return this.width;
      if (this.tendsPortrait) return this.height * this.outputAspectRatio;

      // it's square
      return this.fitCropSquareOutput;
    }

    return this.imageIsLandscape
      ? CANVAS_W
      : parseInt(CANVAS_W * (this.width / this.height), 10);
  }

  get canvasHeight() {
    if (this.isFitCrop) {
      if (this.tendsPortrait) return this.height;
      if (this.tendsLandscape) return this.width / this.outputAspectRatio;

      // it's hip to be square
      return this.fitCropSquareOutput;
    }

    return this.imageIsLandscape
      ? parseInt(CANVAS_H * (this.height / this.width), 10)
      : CANVAS_H;
  }

  get tendsPortrait() {
    // returns true if the rendered output will be taller/narrower than the source image
    // and thus the empty space will show down the sides
    return this.imageAspectRatio < this.outputAspectRatio;
  }

  get tendsLandscape() {
    // returns true if the rendered output will be taller/narrower than the source image
    // and thus the empty space will show down the sides
    return this.imageAspectRatio > this.outputAspectRatio;
  }

  get imageAspectRatio() {
    return this.width / this.height;
  }

  get imageIsLandscape() {
    return this.imageAspectRatio > 1;
  }

  get fitCropSquareOutput() {
    if (this.x > 0) {
      this.height = this.width + this.x * 2;
    } else {
      this.width = this.height + this.y * 2;
    }

    return Math.max(this.width, this.height);
  }
}

export default ThumbnailCropCords;
